import { getCookieData, IS_ANDROID, IS_IOS } from '@repo/common-utils';
import { MAINTENANCE_SETTING_COOKIE, useWorkingPlatform } from '@repo/platform';
import { useAuthContext } from '@repo/user-session';
import { useRouter } from 'next/router';

import { COMMON_PATHS } from '@/lib/constants/paths';

export const useExitService = () => {
  const { workingPlatform, workingPlatformType } = useWorkingPlatform();
  const { auth } = useAuthContext();
  const router = useRouter();

  const exitService = () => {
    if (workingPlatform === 'kbank') {
      if (IS_IOS) {
        window?.webkit?.messageHandlers?.closeKbankWebView?.postMessage('');
      } else if (IS_ANDROID) {
        window?.kbw?.closeKbankWebView();
      }
    } else if (workingPlatformType === 'web' || workingPlatform === 'app') {
      if (workingPlatform === 'app' || !window.opener || window.opener === window) {
        const maintenanceSetting = getCookieData(MAINTENANCE_SETTING_COOKIE);
        router.replace({
          pathname: maintenanceSetting?.status || auth.status === 'logout' ? COMMON_PATHS.환급랜딩 : COMMON_PATHS.환급조회목록,
          query: router.query
        });
      } else {
        window.close();
      }
    }
  };

  return { exitService };
};
